<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg5 xl4>
        <v-card class="card--flex-toolbar">
          <v-app-bar flat>
            <v-toolbar-title class="display-1 text-uppercase">
              <span class="font-weight-light">{{ loginLabel }}</span>
            </v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-text-field v-model="username" :label="userLabel" required v-on:keyup.enter="login"></v-text-field>
            <v-text-field type="password" v-model="password" :label="passwordLabel" required v-on:keyup.enter="login"></v-text-field>

            <v-expand-transition>
                <div
                    v-show="showReg"
                    class="mx-auto"
                >
            <v-text-field v-model="name_last" label="Last Name" required></v-text-field>
            <v-text-field v-model="name_first" label="First Name" required></v-text-field>

                </div>
            </v-expand-transition>

          </v-card-text>
          <v-card-actions>
            <p><v-btn block text @click="click()">{{ loginLabel }}</v-btn></p>
            <p>
                <v-btn v-if="showReg" block text @click="showReg = false">or login</v-btn>
                <v-btn v-if="!showReg" block text @click="showReg = true">or register</v-btn>
            </p>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

var log = console.log

export default {
  props: {
    userLabel: {
      type: String,
      default: 'Email'
    },
    passwordLabel: {
      type: String,
      default: 'Password'
    },
  },
  data () {
    return {
      showReg : false,
      username: '',
      password: '',
      name_last: '',
      name_first: ''
    }
  },
  methods: {
    click() {
        if (this.showReg) {
            this.register()
        } else {
            this.login()
        }
    },
    login () {
      var self = this
      let data = null
      data = {
        email: this.username,
        auth: this.password,
      }
      //this.$emit('login', data)
      this.$store.dispatch('login',data)
      .then(() => {}, e => {
self.$store.commit('showMessage', { content: e.message||"ERROR", color: 'error' })

       })
    },
    register: function() {
      let self = this
      let data = null
      data = {
        email: this.username,
        auth: this.password,
        name_last: this.name_last,
        name_first: this.name_first
      }
      this.$store.dispatch('register',data)
      .then((d) => {
            self.$store.commit('showMessage', 
                { content: d.message, color: 'info' })
          }, e => {
log('ERROR',e)
              self.$store.commit('showMessage', 
                { content: e.message||"ERROR", color: 'error' })
          })
    }
  },
  computed: {
      loginLabel() {
          return this.showReg?'Register':'Login'
      },
  }
}
</script>
<style scoped>
.link {
    cursor: pointer;
    font-weight: bolder;
}
</style>
